import { z } from 'zod';

export const TOUR_STATUS_VALUES = [
  'not_started',
  'active',
  'dismissed',
  'completed',
] as const;
export const TourStatusSchema = z.enum(TOUR_STATUS_VALUES);
export type TourStatus = z.infer<typeof TourStatusSchema>;

export const TourStateSchema = z.object({
  status: TourStatusSchema,
  /** Current stage of the tour machine (see dashboard/lib/tour). */
  stage: z.string(),
  /** Checklist item ids the user has completed. */
  completedSteps: z.array(z.string()),
  demoSpaceId: z.string().optional(),
});
export type TourState = z.infer<typeof TourStateSchema>;

export const DEFAULT_TOUR_STATE: TourState = {
  status: 'not_started',
  stage: 'fork',
  completedSteps: [],
};

export const TourStatePatchSchema = z
  .object({
    status: TourStatusSchema.optional(),
    stage: z.string().optional(),
    completedSteps: z.array(z.string()).optional(),
    demoSpaceId: z.string().optional(),
  })
  .refine(
    (patch) =>
      patch.status !== undefined ||
      patch.stage !== undefined ||
      patch.completedSteps !== undefined ||
      patch.demoSpaceId !== undefined,
    { message: 'At least one tour field must be provided' }
  );
export type TourStatePatch = z.infer<typeof TourStatePatchSchema>;
